import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  newThrowablezl37abp36p5f as newThrowable,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString1h6jjoch8cjt8 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { get_DEVELOPMENT_MODE18ax9b1n971lk as get_DEVELOPMENT_MODE } from './ByteChannel.web.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ClosedReadChannelException9jdpzh6uy12w as ClosedReadChannelException,
  ClosedWriteChannelException1eeenxj0c4bxu as ClosedWriteChannelException,
} from './Exceptions.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { rethrowCloseCauseIfNeededeln8lm5agg4u as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import {
  get_CLOSED3uiwvc5y98ftj as get_CLOSED,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import { ByteWriteChannel3jkhlhzuuoxp1 as ByteWriteChannel } from './ByteWriteChannel.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.i4m_1 = new (Closed())(null);
        var tmp = this;
        // Inline function 'kotlin.Companion.success' call
        tmp.j4m_1 = _Result___init__impl__xyqfz8(Unit_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -231472095;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Empty');
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ {
      constructor(cause) {
        this.k4m_1 = cause;
      }
      toString() {
        return 'Closed(cause=' + toString(this.k4m_1) + ')';
      }
      hashCode() {
        return this.k4m_1 == null ? 0 : hashCode(this.k4m_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Closed()))
          return false;
        if (!equals(this.k4m_1, other.k4m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
function resume() {
  return this.m4m().rc(Companion_getInstance().j4m_1);
}
function resume_0(throwable) {
  var tmp = this.m4m();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new (Result())(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.rc(tmp1_elvis_lhs == null ? Companion_getInstance().j4m_1 : tmp1_elvis_lhs.nt_1);
}
var TaskClass;
function Task() {
  if (TaskClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Task');
    TaskClass = $;
  }
  return TaskClass;
}
var ReadClass;
function Read() {
  if (ReadClass === VOID) {
    class $ {
      constructor(continuation) {
        this.q4m_1 = continuation;
        this.r4m_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.q4m_1), 16));
          stackTraceToString(this_0);
          tmp.r4m_1 = this_0;
        }
      }
      m4m() {
        return this.q4m_1;
      }
      l4m() {
        return this.r4m_1;
      }
      n4m() {
        return 'read';
      }
    }
    protoOf($).o4m = resume;
    protoOf($).p4m = resume_0;
    initMetadataForClass($, 'Read', VOID, VOID, [Task()]);
    ReadClass = $;
  }
  return ReadClass;
}
var WriteClass;
function Write() {
  if (WriteClass === VOID) {
    class $ {
      constructor(continuation) {
        this.s4m_1 = continuation;
        this.t4m_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.s4m_1), 16));
          stackTraceToString(this_0);
          tmp.t4m_1 = this_0;
        }
      }
      m4m() {
        return this.s4m_1;
      }
      l4m() {
        return this.t4m_1;
      }
      n4m() {
        return 'write';
      }
    }
    protoOf($).o4m = resume;
    protoOf($).p4m = resume_0;
    initMetadataForClass($, 'Write', VOID, VOID, [Task()]);
    WriteClass = $;
  }
  return WriteClass;
}
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.x4m_1;
  $this.v4m_1.i4k($this.z4m_1);
  $this.w4m_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.y4m_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write()) {
    tmp = $this.y4m_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.o4m();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new (Closed())(cause) : Companion_getInstance().i4m_1;
  var continuation = $this.y4m_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task())) {
    continuation.p4m(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  var l = (p0) => ClosedReadChannelException().g4n(p0);
  l.callableName = '<init>';
  return l;
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  var l = (p0) => ClosedWriteChannelException().l4n(p0);
  l.callableName = '<init>';
  return l;
}
var ByteChannelClass;
function ByteChannel() {
  if (ByteChannelClass === VOID) {
    class $ {
      constructor(autoFlush) {
        autoFlush = autoFlush === VOID ? false : autoFlush;
        this.u4m_1 = autoFlush;
        this.v4m_1 = new (Buffer())();
        this.w4m_1 = 0;
        this.x4m_1 = new Object();
        this.y4m_1 = atomic$ref$1(Empty_instance);
        this.z4m_1 = new (Buffer())();
        this.a4n_1 = new (Buffer())();
        this.b4n_1 = atomic$ref$1(null);
      }
      m4n() {
        return this.u4m_1;
      }
      n4n() {
        var tmp0_safe_receiver = this.b4n_1.kotlinx$atomicfu$value;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.p4n(ClosedReadChannelException$_init_$ref_ix0089());
        }
        if (this.z4m_1.v3z()) {
          moveFlushToReadBuffer(this);
        }
        return this.z4m_1;
      }
      q4n() {
        if (this.r4n()) {
          var tmp0_safe_receiver = this.b4n_1.kotlinx$atomicfu$value;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            tmp = tmp0_safe_receiver.p4n(ClosedWriteChannelException$_init_$ref_ef15ty());
          }
          if (tmp == null)
            throw ClosedWriteChannelException().l4n();
        }
        return this.a4n_1;
      }
      s4n() {
        var tmp0_safe_receiver = this.b4n_1.kotlinx$atomicfu$value;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t4n();
      }
      r4n() {
        return !(this.b4n_1.kotlinx$atomicfu$value == null);
      }
      u4n() {
        return !(this.s4n() == null) || (this.r4n() && this.w4m_1 === 0 && this.z4m_1.v3z());
      }
      *v4n(min, $completion) {
        rethrowCloseCauseIfNeeded(this);
        if (this.z4m_1.q2() >= fromInt(min))
          return true;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (add(numberToLong(this.w4m_1), this.z4m_1.q2()) < fromInt(min) && this.b4n_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.e11();
            var tmp0 = this_0;
            var tmp2 = new (Read())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.y4m_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.y4m_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.o4m();
                  break $l$block_0;
                }
              }
              if (previous instanceof Read()) {
                previous.p4m(ConcurrentIOException().a4o(tmp2.n4m(), previous.l4m()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.o4m();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.p4m(previous.k4m_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(add(numberToLong(this.w4m_1), this.z4m_1.q2()) < fromInt(min) && this.b4n_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.y4m_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Read()) {
                  tmp = tmp0.y4m_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.o4m();
                }
              }
            }
            return cancellable.oy();
          });
        }
        if (this.z4m_1.q2() < 1048576n) {
          moveFlushToReadBuffer(this);
        }
        return this.z4m_1.q2() >= fromInt(min);
      }
      *c4o($completion) {
        rethrowCloseCauseIfNeeded(this);
        this.d4o();
        if (this.w4m_1 < 1048576)
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (this.w4m_1 >= 1048576 && this.b4n_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.e11();
            var tmp0 = this_0;
            var tmp2 = new (Write())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.y4m_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.y4m_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.o4m();
                  break $l$block_0;
                }
              }
              if (previous instanceof Write()) {
                previous.p4m(ConcurrentIOException().a4o(tmp2.n4m(), previous.l4m()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.o4m();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.p4m(previous.k4m_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(this.w4m_1 >= 1048576 && this.b4n_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.y4m_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Write()) {
                  tmp = tmp0.y4m_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.o4m();
                }
              }
            }
            return cancellable.oy();
          });
        }
        return Unit_instance;
      }
      d4o() {
        if (this.a4n_1.v3z())
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.locks.synchronized' call
        this.x4m_1;
        var count = convertToInt(this.a4n_1.q2());
        this.v4m_1.u4k(this.a4n_1);
        this.w4m_1 = this.w4m_1 + count | 0;
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = this.y4m_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Read()) {
          tmp = this.y4m_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.o4m();
        }
      }
      l6() {
        this.d4o();
        if (!this.b4n_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
      }
      *e4o($completion) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
          yield* this.c4o($completion);
          // Inline function 'kotlin.Companion.success' call
          tmp = _Result___init__impl__xyqfz8(Unit_instance);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        if (!this.b4n_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
        return Unit_instance;
      }
      f4o(cause) {
        if (!(this.b4n_1.kotlinx$atomicfu$value == null))
          return Unit_instance;
        var closedToken = new (CloseToken())(cause);
        this.b4n_1.atomicfu$compareAndSet(null, closedToken);
        var wrappedCause = closedToken.t4n();
        closeSlot(this, wrappedCause);
      }
      toString() {
        return 'ByteChannel[' + hashCode(this) + ']';
      }
    }
    protoOf($).b4o = awaitContent$default;
    initMetadataForClass($, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel(), ByteWriteChannel()], [1, 0]);
    ByteChannelClass = $;
  }
  return ByteChannelClass;
}
var ConcurrentIOExceptionClass;
function ConcurrentIOException() {
  if (ConcurrentIOExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static a4o(taskName, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.q('Concurrent ' + taskName + ' attempts', cause);
        captureStack($this, $this.z4n_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentIOException');
    ConcurrentIOExceptionClass = $;
  }
  return ConcurrentIOExceptionClass;
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  ByteChannel as ByteChannel3cxdguezl3lu7,
};
//endregion

//# sourceMappingURL=ByteChannel.mjs.map
